import React from 'react'
import { render } from 'react-dom'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import Helpers from "../Helpers/Custom";


function MultiBar(props) {
    var colors = ['#194f90', '#7a2d1b', '#d6a419', '#ad967e'];
    const options = {
        chart: {
            type: 'bar',
            height:"200px"
        },
        title: {
            text: ''
        },
       
        xAxis: {
            categories: ['', '', '', ''],
            title: {
                text: null
            }
        },
        yAxis: {
            min: 0,
            // title: {
            //     text: 'Population (millions)',
            //     align: 'high'
            // },
            labels: {
                overflow: 'justify'
            },
          
        },
        tooltip: {
           // valueSuffix: ' millions'
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true
                }
            },
            column: {
                colorByPoint: true
            },series: {
                pointWidth: 25,
                	groupPadding: 0,
                //	pointPadding: 0.1,
                //	borderWidth: 0
              }
        },
        legend: {
            enabled:false
            // layout: 'vertical',
            // align: 'right',
            // verticalAlign: 'top',
            // x: -40,
            // y: 80,
            // floating: true,
            // borderWidth: 1,
            // backgroundColor:
            //     Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
            // shadow: true
        },
        credits: {
            enabled: false
        },
        series: [{
            name: 'Year 1990',
            dataLabels:[
                {formatter: function() {
                    return '<b>'+ Helpers.formatNumberComma(this.y)+'</b>';
                }}
            ],
            data: [{
                y: props?.data[0] || 0,
                color: colors[0]

            }, {
                y: props?.data[1] || 0,
                color: colors[1]

            }, {
                y:  props?.data[2] || 0,
                color: colors[2]

            }, {
                y:  props?.data[3] || 0,
                color: colors[3]

            }],
            //color:"red"
        }]
    };
    
    return (
        <div key={props.key}>
             <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
    )
}

export default MultiBar
